module.exports = __webpack_public_path__ + "static/media/searchIcon.64d5829c.svg";